import { Typography } from '@euler/app/components/typography';
import { Center } from '@euler/components/Center';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo } from 'react';

export const CounterLabel = memo(({ value }: { value: number }) => {
  const { rpx } = useResponsiveContext();
  return (
    <Center
      css={`
        padding: 0 ${rpx(6)}px;
        min-width: ${rpx(24)}px;
        height: ${rpx(18)}px;
        border-radius: ${rpx(9)}px;
        background-color: #2669db;
      `}
    >
      <Typography.Label
        color="#ffffff"
        size={rpx(12)}
        lineHeight={rpx(16)}
        numberOfLines={1}
      >
        {value}
      </Typography.Label>
    </Center>
  );
});
